export const POST_CARD_DIMENSIONS = {
  height: 66,
  width: 146,
};
